import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { FaEnvelope, FaPhoneAlt, FaGlobe, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import "./App.css";
import MedicalSearch from "./medicalSearch";

// Home Component
function Home() {
  return (
    <div className="home">

      {/* Hero Section */}
      <section
        className="hero"
        style={{ backgroundImage: "url('/bg2.jpg')" }}
      >
        <div className="overlay">
          <div className="navbar">
            <Link to="/" className="logo-link">
              <img
                src="/logos.svg"
                alt="The Safe Runway"
                className="logo-img"
              />
            </Link>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section className="intro">
        <h2>Supporting Safer Aviation Decisions</h2>
        <p>
          The Safe Runway provides aviation professionals with <strong>trusted tools for training 
            and medication safety guidance</strong>. Our platform combines expert aviation medical 
            knowledge with digital solutions designed to support safer and more informed decisions.
        </p>
      </section>

      {/* Tools */}
      <section className="tools">
        <h2 className="tools-title">Services</h2>

        <div className="tool-cards">

          {/* LMS */}
          <div className="card">
            <div className="icon-circle">
              <img src="/lms.png" alt="LMS" />
            </div>

            <h3>Learning Management System</h3>

            <ul>
              <li>Aviation safety courses</li>
              <li>CME accredited training</li>
              <li>Interactive learning modules</li>
              <li>Certification upon completion</li>
            </ul>

            <a
              href="https://thesaferunway.myshopify.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn"
            >
              Access LMS
            </a>
          </div>

          {/* Medication */}
          <div className="card">
            <div className="icon-circle">
              <img src="/medicationSearch.png" alt="Medication" />
            </div>

            <h3>Medication Safety Search</h3>

            <ul>
              <li>Check medication safety before flying</li>
              <li>Aviation-specific guidance</li>
              <li>Supports safer decisions</li>
              <li>Supports compliance</li>
            </ul>

            <a
              href="/medical-search"
              target="_blank"
              rel="noopener noreferrer"
              className="btn disabled"
            >
              Search Medication
            </a>
          </div>

        </div>
      </section>

      {/* Contact */}
      <section className="contact">
        <h2>Contact Us</h2>

        <div className="contact-row">

          <a href="mailto:info@thesaferunway.com" className="contact-link">
            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
            </div>
          </a>

        <div className="contact-item">
  <a href="tel:+971503883438" className="contact-link">
    <FaPhoneAlt className="contact-icon" />
  </a>
</div>

          <a
            href="https://thesaferunway.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            <div className="contact-item">
              <FaGlobe className="contact-icon" />
            </div>
          </a>
          <a
            href="https://linkedIn.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            <div className="contact-item">
              <FaLinkedinIn className="contact-icon" />
            </div>
          </a>
          <a
            href="https://www.instagram.com/thesaferunway/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            <div className="contact-item">
              <FaInstagram className="contact-icon" />
            </div>
          </a>
          <a
            href="https://www.instagram.com/thesaferunway/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            <div className="contact-item">
              <FaYoutube className="contact-icon" />
            </div>
          </a>

        </div>
      </section>

    </div>
  );
}


// App Wrapper (THIS was your main issue)
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/medical-search" element={<MedicalSearch />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;